import React, { Fragment } from "react";

export const ReportsPage: React.FC = () => {
  return (
    <Fragment>
      <div>Reports</div>
    </Fragment>
  );
};
